module.exports = __webpack_public_path__ + "img/pv-03.9af3759d.svg";